import { render, staticRenderFns } from "./ProductComparisonTableColumnHeader.vue?vue&type=template&id=1bd96ad4"
import script from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports